import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  // DropdownItem,
} from "reactstrap";

//i18n
import { withNamespaces } from "react-i18next";
// Redux
import { connect, shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";

// users
import emptyUser2 from "../../../assets/images/empty-user-img2.svg";
import { logoutUser } from "../../../store/actions";
import Icon from "../../Icon";
import { get } from "lodash-es";
import { employeeDetailView } from "../../../utils/employee";
import ChangePassword from "../../ChangePassword";
import { alarmSettingPreview } from "../../../utils/AlarmSetting";

const ProfileMenu = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const [profileImg, setProfileImg] = useState('');
  const [name, setName] = useState('');
  const [partName, setPartName] = useState('');
  const [open, setOpen] = useState(false);
  const { employee, user } = useSelector(
    (store) => ({
      employee: store.Profile.employee,
      user: store.Profile.user,
    }),
    shallowEqual
  );
  useEffect(() => {
    setProfileImg(get(employee, 'profileImg') || get(user, 'profileImg', ''));
    setPartName(get(employee, 'partName', ''));
    setName(get(employee, 'name', get(user, 'name', '')));
  }, [employee, user]);

  const selfInfo = () => {
    employeeDetailView(employee.idx);
  };

  const settingInfo = () => {
    alarmSettingPreview(employee.employeeIdx || employee.idx);
  };
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <Icon
            className={{
              'profile-img': profileImg,
              'rounded-circle': profileImg,
            }}
            src={(profileImg) ? profileImg : emptyUser2}
          />
          {/* <span className="d-none d-xl-inline-block ml-8 mr-1">{username}</span>
                        <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i> */}
        </DropdownToggle>
        <DropdownMenu right>
          {name &&
            <div className="user-name">
              {name}
              {partName &&
                <small className="part-name">
                  ({partName})
                </small>
              }
            </div>
          }
          <div className="dropdown-divider"></div>
          <DropdownItem
            tag="a"
            onClick={() => history.push('/profile')}
            disabled={employee?.isMaster}
            style={employee?.isMaster ? { opacity: 0.6 } : {}}
          >
            계정 정보
          </DropdownItem>
          <DropdownItem
            tag="a"
            onClick={selfInfo}
            disabled={employee?.isMaster}
            style={employee?.isMaster ? { opacity: 0.6 } : {}}
          >
            직원 정보
          </DropdownItem>
          <DropdownItem
            tag="a"
            onClick={settingInfo}
            disabled={employee?.isMaster}
            style={employee?.isMaster ? { opacity: 0.6 } : {}}
          >
            알림 설정
          </DropdownItem>
          {employee?.isMaster && (
            <DropdownItem
              tag="a"
              onClick={() => setOpen(true)}
            >
              비밀번호 변경
            </DropdownItem>
          )}
          <button className="dropdown-item" onClick={() => dispatch(logoutUser(history))}>
            로그아웃
          </button>
        </DropdownMenu>
      </Dropdown>

      <ChangePassword
        open={open}
        setOpen={setOpen}
      />
    </React.Fragment >
  );
};

const mapStatetoProps = (state) => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ProfileMenu))
);
